"use client";
import { memo, useEffect, useRef, useState } from "react";
interface CarouselYTItemProps {
	videoId?: string;
	index: number;
	isActive?: boolean;
	href?: string;
}
const CarouselYTItem: React.FC<CarouselYTItemProps> = ({
	videoId,
	isActive,
	index,
	href = "",
}) => {
	const playerRef = useRef<any>(null);
	const playerId = `player-${index}`;

	useEffect(() => {
		if (!videoId) return;

		(window as any).onYouTubeIframeAPIReady = () => {
			playerRef.current = new (window as any).YT.Player(playerId, {
				height: "100%",
				width: "100%",
				videoId,
				playerVars: {
					playsinline: 0,
					controls: 0,
					rel: 0, // don’t show related videos at the end
					modestbranding: 1, // minimal YouTube branding
					showinfo: 0, // (deprecated, but still works sometimes)
					fs: 0, // disable fullscreen button
					disablekb: 1,
				},
				events: {
					onReady: (event: any) => {
						if (isActive) event.target.playVideo();
					},
					onStateChange: (event: any) => {
						console.log("state change");
						if (event.data === (window as any).YT.PlayerState.PLAYING) {
							console.log("Video started");
						}
					},
				},
			});
		};

		return () => {
			if (playerRef.current) {
				playerRef.current?.destroy();
				playerRef.current = null;
			}
		};
	}, [videoId]);

	// Control play/pause when active changes
	useEffect(() => {
		if (!playerRef.current) return;

		if (isActive) {
			playerRef.current.playVideo();
		} else {
			playerRef.current.pauseVideo();
		}
	}, [isActive]);

	return (
		<div className="carousel-item yt-video bg-slate-100 flex items-center justify-center w-full h-full">
			{videoId ? <div id={playerId} /> : <>video</>}
		</div>
	);
};
export default memo(CarouselYTItem);
